import { render, staticRenderFns } from "./CampaingsIcon.vue?vue&type=template&id=0fe8bf30&"
import script from "./CampaingsIcon.vue?vue&type=script&lang=js&"
export * from "./CampaingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports